<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    :disabled="disabledDate"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo tổng hợp giảm giá</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :suppress-row-transform="true"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              dom-layout="scroll"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Hiển thị mã đặt phòng</li>
            <li>Số hóa đơn: Hiển thị số hóa đơn có giảm giá</li>
            <li>Tên khách: Hiển thị tên khách chính cửa đặt phòng</li>
            <li>Tên phòng: Hiển thị tên phòng của đặt phòng</li>
            <li>Ngày tạo hóa đơn: Hiển thị ngày tạo hóa đơn có giảm giá</li>
            <li>Giảm giá dịch vụ trong hóa đơn</li>
            <li>Tiền phòng: Hiển thị số tiền phòng được giảm của đặt phòng</li>
            <li>
              Dịch vụ buồng: Hiển thị tổng tiền giảm giá của dịch vụ buồng(
              không tính gặt là, minibar)
            </li>
            <li>
              Giặt là: Hiển thị tổng số tiền giảm giá của dịch vụ giặt là của
              đặt phòng
            </li>
            <li>Minibar: Hiển thị tổng số tiền giảm giá của Minibar</li>
            <li>
              Tổng giảm: hiển thị tổng số tiền đã giảm giá trong đặt phòng
            </li>
            <li>
              Hóa đơn trước giảm : hiển thị tổng số tiền trước khi giảm giá của
              đặt phòng
            </li>
            <li>Giảm giá : tổng tiền giảm giá của hóa đơn</li>
            <li>
              Hóa đơn sau giảm : Hiển thị tổng số tiền sau khi đã trừ giảm giá
              đặt phòng
            </li>
            <li>Tổng: Hiển thị tổng số tiền giảm giá của từng cột</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListDiscountSummary,
  getListDiscountSummaryExcel
} from '@/api/report_service/discountReport'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'

import InfoBtn from './components/InfoBtn.vue'
import { downFile } from '@/utils/file-handler'

const cellStyle = (params, height) => {
  if (params.data.rowSpan)
    return {
      height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan}px`,
      'border-left': '0.5px solid #ccc',
      'border-right': '0.5px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}

const rowSpan = params => {
  if (params.data.rowSpan) {
    return params.data.rowSpan
  }

  return 1
}
const cellStyle2 = () => {
  return {
    'border-left': '1px solid #ccc',
    // 'border-right': '1px solid #ccc',
    'border-bottom': '0.5px solid #ccc',
    top: 0,
    background: '#fff'
  }
}

export default {
  components: {
    CalendarSelect,
    CalendarRange,
    SelectWithSearchTable,
    InfoBtn
  },
  data() {
    return {
      dataKey: 0,
      disabledDate: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIds: []
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIds: []
      },

      columns: [
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          tooltipField: 'recode',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          cellStyle: cellStyle,
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 110
        },

        {
          headerName: 'Tên khách',
          field: 'guest_name',
          tooltipField: 'guest_name',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          cellStyle: cellStyle,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120,
          flex: 1
          // maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.invoiceNumber'),
          field: 'invoice_code',
          tooltipField: 'invoice_code',
          cellStyle: cellStyle2,

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 130
        },

        {
          headerName: 'Hóa đơn trước giảm',
          field: 'price_before_discount',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          cellStyle: cellStyle2,

          // tooltipField: 'reception',
          // cellRenderer: 'CellRenderTextInput',

          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: 'Giảm giá',
          field: 'discount',
          tooltipField: 'discount',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          cellStyle: cellStyle2,
          minWidth: 150
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Giá sau giảm',
          field: 'price_after_discount',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          cellStyle: cellStyle2,
          minWidth: 150
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },

  created() {
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },

    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },

    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    tranferRow(data) {
      let newRowsData = []
      data.forEach(element => {
        if (element?.info_list?.length > 0) {
          element.info_list[0] = {
            ...element.info_list[0],
            rowSpan: element.info_list.length,
            recode: element.recode,
            guest_name: element.guest_name
          }
          newRowsData = [...newRowsData, ...element.info_list]
        }
      })
      return newRowsData
    },
    async attachData() {
      try {
        this.loading = true

        const data = await getListDiscountSummary(this.searchParams)
        // console.log(data.data)
        this.rows = this.tranferRow(data.data)
        // if (data.data?.transactions?.length > 0) {
        //   this.rows = [
        //     ...data.data?.transactions,
        //     {
        //       create_date: 'Tổng',
        //       card: data.data.card_total,

        //       transfer: data.data.transfer_total,
        //       debt: data.data.debt_total,
        //       free: data.data.free_total,
        //       cash: data.data.cash_total,
        //       rowHeightTotal: true
        //     }
        //   ]
        // } else {
        //   this.rows = []
        // }
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.loading = false
      }
    },
    async downloadExcel() {
      try {
        this.loading = true

        const res = await getListDiscountSummaryExcel(this.searchParams)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(res, 'bao_cao_tong_hop_giam_gia_' + date + '.xlsx')
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.loading = false
      }
    },

    onReset() {
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.searchParams = { ...this.defaultSearchParams }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
